<h2 mat-dialog-title>Importer des sites à partir d'un fichier CSV/Excel</h2>

<mat-dialog-content>
    <div class="flex flex-col h-full">

        <h1 class="font-medium ml-1 my-3">Sélectionner un fichier</h1>
        <div class="flex flex-row w-full">
            <input 
                #fileInput 
                style="display: none; height: 0%;"
                type="file" 
                (change)="onFileSelected($event)" 
                [accept]="['.csv','.xls','.xlsx']"
                [multiple]="false" 
                />
            
            <div class="w-full flex flex-row items-center">
                <mat-form-field >
                    <input matInput disabled [(ngModel)]="selectedFileName">
                </mat-form-field>
                <button class="ml-2 mb-5" mat-icon-button (click)="fileInput.click()"><mat-icon>upload_file</mat-icon></button>
                <mat-checkbox class="ml-1 mb-5" [(ngModel)]="includeHeader">Avec entête</mat-checkbox>
            </div>
        </div>
    
        @if (selectedFile()) {
            <div class="flex flex-row items-center my-3">
                <mat-icon>warning</mat-icon><h1 class="font-medium ml-1 mr-2">Veuillez sélectionner le champ correspondant à chaque colonne </h1>
            </div>
        }
    
        <ag-grid-angular
            class="grid-dimensions"
            [localeText]="gridLocale"
            [columnDefs]="siteSelectionColumns"
            [context]="gridContext"
            [rowData]="siteSelectionRowData()"
            [loadingOverlayComponent]="loadingOverlayComponent"
            [loadingOverlayComponentParams]="loadingOverlayComponentParams"
            [rowSelection]="{mode: 'multiRow', enableClickSelection: true, enableSelectionWithoutKeys: true}"
            [animateRows]="false"
            [autoSizeStrategy]="autoSizeStrategy"
            (gridReady)="onSiteSelectionGridReady($event)"
            (selectionChanged)="onSiteSelectionChanged($event)"
            (rowDataUpdated)="onRowDataUpdated()"
            />
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]>Annuler</button>
    <button mat-stroked-button  [disabled]="selectedRows().length === 0 || !isColumnFieldSet || isImportingSites()" (click)="checkColumnFieldsThenImportSites()">
        @if (isImportingSites()) {
            <i class="spinner-btn custom-spinner"></i>
        } @else {
            Importer {{selectedRows().length}} sites
        }
    </button>
</mat-dialog-actions>